var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepCheckItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_535_6891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1859 12.8816H25.8702V8.29303H34.1859V12.8816Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.217 8.29303H29.4968V11.6486H27.217V8.29303Z",
    fill: "#D0CFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81409 8.29303H11.1297V12.8816H2.81409V8.29303Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16089 8.29303H6.44064V11.6486H4.16089V8.29303Z",
    fill: "#D0CFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0514 8.70829H22.0735V4.90249C22.0735 4.55838 21.7938 4.27863 21.4497 4.27863H15.5504C15.2063 4.27863 14.9266 4.55838 14.9266 4.90249V8.70829H11.9487V4.90249C11.9487 2.9166 13.5645 1.30078 15.5504 1.30078H21.4497C23.4356 1.30078 25.0514 2.9166 25.0514 4.90249V8.70829Z",
    fill: "#A6B6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9487 5.20935H14.9266V8.70831H11.9487V5.20935Z",
    fill: "#7A8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0735 5.20935H25.0513V8.70831H22.0735V5.20935Z",
    fill: "#7A8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1497 7.4425H33.6896C33.2199 7.4425 32.8394 7.82331 32.8394 8.29304V10.5496C32.8394 11.0521 32.4317 11.4597 31.9293 11.4597H28.1271C27.6244 11.4597 27.217 11.0524 27.217 10.5496V8.29304C27.217 7.82331 26.8362 7.4425 26.3665 7.4425H10.6335C10.1638 7.4425 9.78296 7.82331 9.78296 8.29304V10.5496C9.78296 11.0521 9.37562 11.4597 8.87286 11.4597H5.07101C4.56826 11.4597 4.16092 11.0524 4.16092 10.5496V8.29304C4.16092 7.82331 3.78011 7.4425 3.31039 7.4425H0.85025C0.380806 7.4425 0 7.82331 0 8.29304V33.0742C0 34.5167 1.16952 35.6862 2.61201 35.6862H34.388C35.8305 35.6862 37 34.5167 37 33.0742V8.29304C37 7.82331 36.6192 7.4425 36.1497 7.4425Z",
    fill: "#FF889E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23346 33.0742V8.29306C2.23346 7.82333 2.61398 7.44281 3.08371 7.44281H0.85025C0.380806 7.44253 0 7.82333 0 8.29306V33.0742C0 34.5167 1.16952 35.6862 2.61201 35.6862H4.84547C3.40298 35.6862 2.23346 34.5167 2.23346 33.0742V33.0742Z",
    fill: "#F9496E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3162 14.9819H5.68391C4.60049 14.9819 3.72229 15.8601 3.72229 16.9435V30.0024C3.72229 31.0858 4.60049 31.964 5.68391 31.964H31.3165C32.3996 31.964 33.2778 31.0858 33.2778 30.0024V16.9435C33.2778 15.8601 32.3996 14.9819 31.3162 14.9819V14.9819Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95575 30.0024V16.9435C5.95575 15.8601 6.83395 14.9819 7.91737 14.9819H5.68391C4.60049 14.9822 3.72229 15.8601 3.72229 16.9435V30.0024C3.72229 31.0858 4.60049 31.964 5.68391 31.964H7.91737C6.83395 31.964 5.95575 31.0858 5.95575 30.0024V30.0024Z",
    fill: "#D0CFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7893 21.7949H20.1779V19.1834C20.1779 18.8026 19.8693 18.4941 19.4885 18.4941H17.5117C17.1309 18.4941 16.822 18.8026 16.822 19.1834V21.7949H14.2106C13.8298 21.7949 13.5212 22.1037 13.5212 22.4845V24.4614C13.5212 24.8422 13.8298 25.1507 14.2106 25.1507H16.822V27.7621C16.822 28.143 17.1309 28.4518 17.5117 28.4518H19.4885C19.8693 28.4518 20.1779 28.143 20.1779 27.7621V25.1507H22.7893C23.1701 25.1507 23.4789 24.8422 23.4789 24.4614V22.4845C23.4789 22.1037 23.1701 21.7949 22.7893 21.7949V21.7949Z",
    fill: "#F9496E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_535_6891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepCheckItems);
export default __webpack_public_path__ + "static/media/PrepCheckItems.532990995df88f5831ff1ceae16b11cd.svg";
export { ForwardRef as ReactComponent };